import { useState, useEffect } from 'react';
import { Link, useParams, useHistory } from 'react-router-dom';
import { fetchData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Select from 'react-select';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import SaveIcon from '@mui/icons-material/Save';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import './Role.css';

const RoleDetail = () => {
    const { id } = useParams();
    const history = useHistory();
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();
    const [selectedOption, setSelectedOption] = useState({ value: '1', label: 'Master' });
    const [successMessage, setSuccessMessage] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [formData, setFormData] = useState({ Name: '', Claims: [], UpdatedBy: userId });

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) { logout(); return; }
    }, [isAuthenticated, companyId, token]);

    useEffect(() => {
        fetchData('RoleApi', `/RoleDetails/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111' && response.response_data) {
                    const { RoleVM } = response.response_data;
                    setFormData((prev) => ({
                        ...prev, ...RoleVM,
                        Claims: response.response_data.Claims ? response.response_data.Claims.map((c) => ({ ...c })) : [],
                    }));
                }
            })
            .catch((e) => { console.error('Error fetching Role Details:', e); setErrorMessage('Error fetching role details.'); });
    }, [id]);

    const getClaimRange = () => {
        const startIndex = (parseInt(selectedOption.value, 10) - 1) * 5;
        return { startIndex, endIndex: startIndex + 4 };
    };

    const handleChange = (index) => {
        const updatedClaims = [...formData.Claims];
        updatedClaims[index].IsSelected = !updatedClaims[index].IsSelected;
        setFormData((prev) => ({ ...prev, Claims: updatedClaims }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        updateData('RoleApi', `${id}`, formData, token)
            .then(() => {
                setSuccessMessage('Record updated successfully.');
                setErrorMessage('');
                history.push(`/roleDetail/${id}`);
            })
            .catch((e) => { console.error('Error updating record:', e); setErrorMessage('Error updating role.'); });
    };

    return (
        <div className="role-container">
            <div className="role-header-card">
                <div className="role-header-content">
                    <div className="role-title-section">
                        <span className="role-title-icon"><AdminPanelSettingsIcon fontSize="small" /></span>
                        <h1 className="role-title">Role Details</h1>
                    </div>
                    <div className="role-header-actions">
                        <button className="rol-btn rol-btn-primary" onClick={handleSubmit}>
                            <SaveIcon style={{ fontSize: 14 }} />&nbsp;Update
                        </button>
                        <Link to="/RoleIndex" className="rol-btn rol-btn-cancel">
                            <ArrowBackIcon style={{ fontSize: 14 }} />&nbsp;Cancel
                        </Link>
                    </div>
                </div>
            </div>

            {errorMessage && <div className="role-alert role-alert-error">{errorMessage}</div>}
            {successMessage && <div className="role-alert role-alert-success">{successMessage}</div>}

            <div className="role-form-card">
                <p className="role-form-section-title">Role Information</p>
                <div className="role-form-row">
                    <div className="role-form-group" style={{ maxWidth: '320px' }}>
                        <label className="role-label">Role Name</label>
                        <input className="role-input" type="text" name="Name" value={formData.Name} readOnly placeholder="Role name" />
                    </div>
                </div>
            </div>

            <div className="role-panel-card">
                <div className="role-panel-header">
                    <span className="role-panel-title">Claims</span>
                </div>
                <div className="role-panel-body">
                    <div className="role-form-group" style={{ maxWidth: '260px', marginBottom: '4px' }}>
                        <label className="role-label">Claim Category</label>
                        <Select
                            options={[
                                { value: '1', label: 'Master' },
                                { value: '2', label: 'Transaction' },
                                { value: '3', label: 'Reports' },
                                { value: '4', label: 'Administration' },
                            ]}
                            value={selectedOption}
                            onChange={setSelectedOption}
                        />
                    </div>
                    <div className="role-claims-list">
                        {formData.Claims && formData.Claims.length > 0 ? (
                            formData.Claims.map((claim, index) => {
                                const { startIndex, endIndex } = getClaimRange();
                                if (index < startIndex || index > endIndex) return null;
                                return (
                                    <div key={index} className="role-claim-item">
                                        <input type="hidden" name={`Claims[${index}].ClaimType`} value={claim.ClaimType} />
                                        <input type="hidden" name={`Claims[${index}].ClaimValue`} value={claim.ClaimValue} />
                                        <input type="hidden" name={`Claims[${index}].LogInClaims`} value={claim.LogInClaims} />
                                        <input
                                            type="checkbox"
                                            id={`claimCheckbox${index}`}
                                            className="role-checkbox"
                                            checked={claim.IsSelected}
                                            onChange={() => handleChange(index)}
                                        />
                                        <label htmlFor={`claimCheckbox${index}`} className="role-checkbox-label">{claim.ClaimValue}</label>
                                    </div>
                                );
                            })
                        ) : <p className="role-empty-text">No claims available.</p>}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RoleDetail;
